<template>
    <div class="col-md-12 px-0 py-0">
        <div class="col-md-12 text-right text-success">
            <span style="font-size: 20px">Log de cambios</span>
        </div>
        <div>
            <table class="table table-bordered table-striped table-sm mt-5">
                <thead>
                    <tr>
                        <th>Opciones</th>
                        <th>Nombre proyecto</th>
                        <th>Concurso</th>
                        <th>Fecha</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="change in changes" :key="change.id">
                        <td>
                            <button
                                type="button"
                                @click="show_change(change)"
                                class="btn btn-warning btn-sm"
                                data-toggle="modal"
                                data-target="#exampleModal"
                            >
                                <em class="fa fa-eye"></em>
                            </button>
                        </td>
                        <td v-text="change.project.name"></td>
                        <td v-text="change.contest.name"></td>
                        <td v-text="change.created_at"></td>
                    </tr>
                </tbody>
            </table>
            <nav>
                <ul class="pagination">
                    <li class="page-item" v-if="pagination.current_page > 1">
                        <a
                            class="page-link"
                            href="#"
                            @click="changePage(pagination.current_page - 1)"
                            >Ant</a
                        >
                    </li>
                    <li
                        class="page-item"
                        v-for="page in pagesNumber"
                        :key="page"
                        :class="[page == isActived ? 'active' : '']"
                    >
                        <a
                            class="page-link"
                            href="#"
                            @click="changePage(page)"
                            v-text="page"
                        ></a>
                    </li>
                    <li
                        class="page-item"
                        v-if="pagination.current_page < pagination.last_page"
                    >
                        <a
                            class="page-link"
                            href="#"
                            @click="changePage(pagination.current_page + 1)"
                            >Sig</a
                        >
                    </li>
                </ul>
            </nav>
        </div>
        <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="d-flex justify-content-around mt-2">
                            <div
                                class="m-3"
                                style="
                                    width: 800px;
                                    padding: 5px;
                                    white-space: nowrap;
                                    overflow-x: auto;
                                "
                            >
                                <div>
                                    <h5>Valor inicial</h5>
                                    <vue-json-pretty
                                        :path="'res'"
                                        :data="initial_value"
                                    >
                                    </vue-json-pretty>
                                </div>
                            </div>
                            <div
                                class="m-3"
                                style="
                                    width: 800px;
                                    padding: 5px;
                                    white-space: nowrap;
                                    overflow-x: auto;
                                "
                            >
                                <div>
                                    <h5>Valor actual</h5>
                                    <vue-json-pretty
                                        v-if="actual_value"
                                        :path="'res'"
                                        :data="actual_value"
                                    >
                                    </vue-json-pretty>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
export default {
    components: {
        VueJsonPretty,
    },
    props: {
        model_id: Number,
    },
    data() {
        return {
            changes: [],
            show_modal: false,
            initial_value: null,
            actual_value: null,
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            model: "",
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getChangesModel(page);
        },
        getChangesModel(page = 1) {
            let me = this;
            axios
                .get(
                    "/api/users/changes/user/" +
                        me.model_id +
                        "?page=" +
                        page
                )
                .then(function (response) {
                    me.changes = response.data.project_changes.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
        changeView(page, id, name) {
            this.$emit("change", { page: page, id: id });
        },
        show_change(data) {
            let me = this;
            me.initial_value = JSON.parse(data.initial_value);
            me.actual_value = JSON.parse(data.actual_value);
        },
    },
    mounted() {
        let me = this;
        me.getChangesModel();
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}

.celda {
    height: auto;
    width: 400px;
}
</style>
